import React from "react";
import { Box, Divider, Grid, Typography, useTheme } from "@mui/material";

export const SectionHeader: React.FC<{
  title: string;
  description?: string;
}> = ({ title, description }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "1.25rem",
          fontWeight: 700,
          lineHeight: "normal",
          color: theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontSize: "0.875rem",
            color: theme.palette.text.primary,
            lineHeight: "1rem",
            mt: 1,
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export const SectionDivider: React.FC = () => (
  <Divider sx={{ opacity: 0.6, my: 1 }} />
);

export const FieldGrid: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Grid container spacing={2}>
    {React.Children.toArray(children).map((child, index) => (
      <Grid item xs={12} md={6} key={index}>
        {child}
      </Grid>
    ))}
  </Grid>
);

export const StepContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 3,
      py: 2,
      "& .MuiOutlinedInput-root": { borderRadius: "8px" },
      "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
    }}
  >
    {children}
  </Box>
);
